<template>
  <div class="row mb-3">
    <div class="col-sm-12">
      <div class="card mb-3">
        <!-- Form body -->
        <div class="card-body">
          <form @submit.prevent="add">
            <!-- Input fields -->
            <div class="row g-3 align-items-center">
              <!-- Parent Scene -->
              <div class="col-md-6">
                <label class="form-label">Parent Scene</label>
                <select
                  class="form-select"
                  v-model.number="nitem.parentSceneId"
                  name="specialityDropdown5"
                >
                  <option :value="null"></option>
                  <option
                    v-for="item in scenesWithChoices"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <span class="inputError">
                  {{ errors.first("specialityDropdown5") }}
                </span>
              </div>

              <!-- Parent Choices -->
              <div class="col-md-6">
                <label class="form-label">Parent Choices</label>
                <select
                  class="form-select"
                  v-model.number="nitem.parentChoiceId"
                >
                  <option :value="null"></option>
                  <option
                    v-for="choice in filteredChoices"
                    :key="choice.id"
                    :value="choice.id"
                  >
                    {{ choice.textEn }}
                  </option>
                </select>
              </div>

              <!-- Name -->
              <div class="col-md-6">
                <label for="firstName" class="form-label">Name</label>
                <input
                  type="text"
                  v-model="nitem.name"
                  name="name"
                  id="firstName"
                  class="form-control"
                  v-validate="{ required: true }"
                />
                <span class="inputError">{{ errors.first("name") }}</span>
              </div>

              <!-- Scenario -->
              <div class="col-md-6">
                <label class="form-label">Scenario</label>
                <select
                  class="form-select"
                  v-model.number="nitem.scenarioId"
                  name="specialityDropdown"
                  required
                >
                  <option
                    v-for="(item, index) in scenarios"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
                <span class="inputError">
                  {{ errors.first("specialityDropdown") }}
                </span>
              </div>

              <!-- DescriptionAz -->
              <div class="col-md-12">
                <label for="DescriptionAz" class="form-label">
                  DescriptionAz
                </label>
                <textarea
                  rows="3"
                  v-model="nitem.descriptionAz"
                  name="DescriptionAz"
                  id="DescriptionAz"
                  class="form-control"
                  v-validate="{ required: true }"
                ></textarea>
                <span class="inputError">
                  {{ errors.first("DescriptionAz") }}
                </span>
              </div>

              <!-- DescriptionEn -->
              <div class="col-md-12">
                <label for="DescriptionEn" class="form-label">
                  DescriptionEn
                </label>
                <textarea
                  rows="3"
                  v-model="nitem.descriptionEn"
                  name="DescriptionEn"
                  id="DescriptionEn"
                  class="form-control"
                  v-validate="{ required: true }"
                ></textarea>
                <span class="inputError">
                  {{ errors.first("DescriptionEn") }}
                </span>
              </div>

              <!-- LocationAz -->
              <div class="col-md-6">
                <label for="LocationAz" class="form-label">LocationAz</label>
                <input
                  type="text"
                  v-model="nitem.locationAz"
                  name="LocationAz"
                  id="LocationAz"
                  class="form-control"
                />
                <span class="inputError">{{ errors.first("LocationAz") }}</span>
              </div>

              <!-- LocationEn -->
              <div class="col-md-6">
                <label for="LocationEn" class="form-label">LocationEn</label>
                <input
                  type="text"
                  v-model="nitem.locationEn"
                  name="LocationEn"
                  id="LocationEn"
                  class="form-control"
                />
                <span class="inputError">{{ errors.first("LocationEn") }}</span>
              </div>

              <!-- Character -->
              <div class="col-md-6">
                <label class="form-label">Character</label>
                <select
                  class="form-select"
                  v-model.number="nitem.characterId"
                  name="specialityDropdown2"
                >
                  <option :value="null"></option>
                  <option
                    v-for="(item, index) in characters"
                    :key="index"
                    :value="item.id"
                  >
                    {{ item.nameEn }}
                  </option>
                </select>
                <span class="inputError">
                  {{ errors.first("specialityDropdown2") }}
                </span>
              </div>

              <!-- isQuestion -->
              <div class="col-md-6">
                <label class="form-label">isQuestion</label>
                <select
                  class="form-select"
                  v-model.number="nitem.isQuestion"
                  name="specialityDropdown3"
                >
                  <option :value="true">Yes</option>
                  <option :value="false">No</option>
                </select>
                <span class="inputError">
                  {{ errors.first("specialityDropdown3") }}
                </span>
              </div>
              <div class="col-md-6" v-if="!nitem.isQuestion">
                <label class="form-label">Next Choice</label>
                <select class="form-select" v-model.number="nitem.nextSceneId">
                  <option :value="null"></option>
                  <option
                    v-for="item in scenesWithChoices"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>

              <!-- Image -->
              <div class="col-md-6">
                <label for="Image" class="form-label">Image</label>
                <input
                  type="file"
                  @change="handleFileChange"
                  name="Image"
                  id="Image"
                  class="form-control"
                />
                <span class="inputError">{{ errors.first("Image") }}</span>
              </div>

              <!-- Question / Answers -->
              <div v-if="nitem.isQuestion">
                <hr />
                <br />

                <h3>Answer 1</h3>
                <br />
                <div class="col-md-12 mt-4">
                  <label for="textAz1" class="form-label">TextAz</label>
                  <input
                    type="text"
                    v-model="nitem.choices[0].textAz"
                    name="textAz1"
                    id="textAz1"
                    class="form-control"
                  />
                  <span class="inputError">{{ errors.first("textAz1") }}</span>
                </div>

                <div class="col-md-12 mt-4">
                  <label for="textEn1" class="form-label">TextEn</label>
                  <input
                    type="text"
                    v-model="nitem.choices[0].textEn"
                    name="textEn1"
                    id="textEn1"
                    class="form-control"
                  />
                  <span class="inputError">{{ errors.first("textEn1") }}</span>
                </div>

                <div class="col-md-6 mt-4">
                  <label class="form-label">ChoiceValues</label>
                  <select
                    class="form-select"
                    v-model.number="nitem.choices[0].choiceValueId"
                    name="specialityDropdown4_1"
                  >
                    <option :value="null"></option>
                    <option
                      v-for="(item, index) in choiceValues"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <span class="inputError">
                    {{ errors.first("specialityDropdown4_1") }}
                  </span>
                </div>
                <label class="form-label">Next Scene</label>
                <select
                  class="form-select"
                  v-model.number="nitem.choices[0].nextSceneId"
                >
                  <option :value="null"></option>
                  <option
                    v-for="item in scenesWithChoices"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>

                <div class="col-md-6 mt-4">
                  <label class="form-label">Is Correct?</label>
                  <select
                    class="form-select"
                    v-model="nitem.choices[0].isCorrect"
                  >
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>

                <hr />
                <br />

                <h3>Answer 2</h3>
                <br />
                <div class="col-md-12 mt-4">
                  <label for="textAz2" class="form-label">TextAz</label>
                  <input
                    type="text"
                    v-model="nitem.choices[1].textAz"
                    name="textAz2"
                    id="textAz2"
                    class="form-control"
                  />
                  <span class="inputError">{{ errors.first("textAz2") }}</span>
                </div>

                <div class="col-md-12 mt-4">
                  <label for="textEn2" class="form-label">TextEn</label>
                  <input
                    type="text"
                    v-model="nitem.choices[1].textEn"
                    name="textEn2"
                    id="textEn2"
                    class="form-control"
                  />
                  <span class="inputError">{{ errors.first("textEn2") }}</span>
                </div>

                <div class="col-md-6 mt-4">
                  <label class="form-label">ChoiceValues</label>
                  <select
                    class="form-select"
                    v-model.number="nitem.choices[1].choiceValueId"
                    name="specialityDropdown4_2"
                  >
                    <option :value="null"></option>
                    <option
                      v-for="(item, index) in choiceValues"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <span class="inputError">
                    {{ errors.first("specialityDropdown4_2") }}
                  </span>
                </div>

                <label class="form-label">Next Scene</label>
                <select
                  class="form-select"
                  v-model.number="nitem.choices[1].nextSceneId"
                >
                  <option :value="null"></option>
                  <option
                    v-for="item in scenesWithChoices"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>

                <div class="col-md-6 mt-4">
                  <label class="form-label">Is Correct?</label>
                  <select
                    class="form-select"
                    v-model="nitem.choices[1].isCorrect"
                  >
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>

                <hr />
                <br />

                <h3>Answer 3</h3>
                <br />
                <div class="col-md-12 mt-4">
                  <label for="textAz3" class="form-label">TextAz</label>
                  <input
                    type="text"
                    v-model="nitem.choices[2].textAz"
                    name="textAz3"
                    id="textAz3"
                    class="form-control"
                  />
                  <span class="inputError">{{ errors.first("textAz3") }}</span>
                </div>

                <div class="col-md-12 mt-4">
                  <label for="textEn3" class="form-label">TextEn</label>
                  <input
                    type="text"
                    v-model="nitem.choices[2].textEn"
                    name="textEn3"
                    id="textEn3"
                    class="form-control"
                  />
                  <span class="inputError">{{ errors.first("textEn3") }}</span>
                </div>

                <div class="col-md-6 mt-4">
                  <label class="form-label">ChoiceValues</label>
                  <select
                    class="form-select"
                    v-model.number="nitem.choices[2].choiceValueId"
                    name="specialityDropdown4_3"
                  >
                    <option :value="null"></option>
                    <option
                      v-for="(item, index) in choiceValues"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                  <span class="inputError">
                    {{ errors.first("specialityDropdown4_3") }}
                  </span>
                </div>

                <label class="form-label">Next Scene</label>
                <select
                  class="form-select"
                  v-model.number="nitem.choices[2].nextSceneId"
                >
                  <option :value="null"></option>
                  <option
                    v-for="item in scenesWithChoices"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ item.name }}
                  </option>
                </select>

                <div class="col-md-6 mt-4">
                  <label class="form-label">Is Correct?</label>
                  <select
                    class="form-select"
                    v-model="nitem.choices[2].isCorrect"
                  >
                    <option :value="true">Yes</option>
                    <option :value="false">No</option>
                  </select>
                </div>
              </div>
            </div>

            <!-- Submit button -->
            <button
              type="submit"
              class="btn btn-primary mt-4"
              :disabled="loading"
            >
              Save
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import jwtInterceptor from "../../../jwt.interceptor";

export default {
  name: "SceneUpdate",
  data() {
    return {
      nitem: {
        isQuestion: false,
        choices: [
          {
            textAz: "",
            textEn: "",
            choiceValueId: null,
            isCorrect: false,
            nextSceneId: null,
          },
          {
            textAz: "",
            textEn: "",
            choiceValueId: null,
            isCorrect: false,
            nextSceneId: null,
          },
          {
            textAz: "",
            textEn: "",
            choiceValueId: null,
            isCorrect: false,
            nextSceneId: null,
          },
        ],
      },
      scenarios: [],
      characters: [],
      choiceValues: [],
      scenesWithChoices: [],
      loading: false,
    };
  },
  computed: {
    filteredChoices() {
      const scene = this.scenesWithChoices.find(
        (x) => x.id === this.nitem.parentSceneId,
      );
      return scene ? scene.choices : [];
    },
  },
  watch: {
    "nitem.parentSceneId"(newVal, oldVal) {
      if (oldVal === undefined || oldVal === null) return;

      if (newVal !== oldVal) {
        this.nitem.parentChoiceId = null;
      }
    },
  },

  methods: {
    appendIfFilled(formData, key, value) {
      if (value === null || value === undefined) return;
      if (typeof value === "string" && value.trim() === "") return;
      formData.append(key, value);
    },

    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.nitem.image = file;
      }
    },

    async add() {
      const validForm = await this.isFormValid();
      if (!validForm) {
        this.$toast.error(
          "Cells are not filled correctly. Check the boxes again!",
          {
            position: "top-right",
          },
        );
        this.loading = false;
        return;
      }

      if (this.nitem.isQuestion) {
        while (this.nitem.choices.length > 1) {
          const lastChoice = this.nitem.choices[this.nitem.choices.length - 1];
          const isEmptyAz = !lastChoice?.textAz || lastChoice.textAz.trim() === "";
          const isEmptyEn = !lastChoice?.textEn || lastChoice.textEn.trim() === "";
          if (isEmptyAz && isEmptyEn) {
            this.nitem.choices.pop();
          } else {
            break;
          }
        }
      }

      this.loading = true;
      const formData = new FormData();

      // REQUIRED sahələr
      formData.append("Name", this.nitem.name);
      formData.append("DescriptionAz", this.nitem.descriptionAz);
      formData.append("DescriptionEn", this.nitem.descriptionEn);
      formData.append("IsQuestion", this.nitem.isQuestion);
      formData.append("ScenarioId", this.nitem.scenarioId);
      const parentScene = this.scenesWithChoices.find(
        (s) => s.id === this.nitem.parentSceneId,
      );

      const nextChoice = parentScene?.choices?.[0] || null;
      // OPTIONAL sahələr
      this.appendIfFilled(formData, "LocationAz", this.nitem.locationAz);
      this.appendIfFilled(formData, "LocationEn", this.nitem.locationEn);
      this.appendIfFilled(formData, "CharacterId", this.nitem.characterId);
      this.appendIfFilled(formData, "ParentSceneId", this.nitem.parentSceneId);
      this.appendIfFilled(
        formData,
        "ParentChoiceId",
        this.nitem.parentChoiceId,
      );

      // if (this.nitem.nextSceneId) {
      //   formData.append("Choices[0].Id", nextChoice.id);
      //   formData.append("Choices[0].TextAz", "Növbəti");
      //   formData.append("Choices[0].TextEn", "Next");
      //   formData.append("Choices[0].NextSceneId", this.nitem.nextSceneId);
      //   formData.append("Choices[0].ChoiceValueId", 1);
      // }

      if (this.nitem.nextSceneId && !this.nitem.isQuestion) {
        // UPDATE-dirsə
        if (this.nitem.choices?.length) {
          this.appendIfFilled(
            formData,
            "Choices[0].Id",
            this.nitem.choices[0].id,
          );
        }

        this.appendIfFilled(formData, "Choices[0].TextAz", "Növbəti");
        this.appendIfFilled(formData, "Choices[0].TextEn", "Next");
        this.appendIfFilled(
          formData,
          "Choices[0].NextSceneId",
          this.nitem.nextSceneId,
        );
        this.appendIfFilled(formData, "Choices[0].ChoiceValueId", null);
        this.appendIfFilled(formData, "Choices[0].IsCorrect", this.nitem.choices?.[0]?.isCorrect ?? true);
      }

      if (this.nitem.image !== undefined && this.nitem.image !== null) {
        formData.append("Image", this.nitem.image);
      }
      if (this.nitem.isQuestion && Array.isArray(this.nitem.choices)) {
        this.nitem.choices.forEach((choice, index) => {
          this.appendIfFilled(formData, `Choices[${index}].Id`, choice.id);

          this.appendIfFilled(
            formData,
            `Choices[${index}].TextAz`,
            choice.textAz,
          );
          this.appendIfFilled(
            formData,
            `Choices[${index}].TextEn`,
            choice.textEn,
          );
          this.appendIfFilled(
            formData,
            `Choices[${index}].ChoiceValueId`,
            choice.choiceValueId,
          );
          this.appendIfFilled(
            formData,
            `Choices[${index}].IsCorrect`,
            choice.isCorrect,
          );

          this.appendIfFilled(
            formData,
            `Choices[${index}].NextSceneId`,
            choice.nextSceneId,
          );
        });
      }

      jwtInterceptor
        .put(this.$store.getters.getUrl + "/Scenes/" + this.id, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(() => {
          this.$toast.success("Added", {
            position: "top-right",
          });
          this.loading = false;
          this.$router.back();
        })
        .catch((e) => {
          this.$toast.error(e?.response?.data?.title || "Error", {
            position: "top-right",
          });
          this.loading = false;
          if (!this.nitem.choices) this.nitem.choices = [];
          while (this.nitem.choices.length < 3) {
            this.nitem.choices.push({
              textAz: "",
              textEn: "",
              choiceValueId: null,
              isCorrect: false,
              nextSceneId: null,
            });
          }
        });
    },

    getScenarios() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/Scenarios")
        .then((response) => {
          this.scenarios = response.data;

          const mainScenario = this.scenarios.find((x) => x.isMain === true);
          if (mainScenario && !this.nitem.scenarioId) {
            this.nitem.scenarioId = mainScenario.id;
          }
        });
    },
    async getScene() {
      const response = await jwtInterceptor.get(
        this.$store.getters.getUrl + "/Scenes/" + this.id,
      );

      this.nitem = response.data;

      if (this.nitem.choices && this.nitem.choices.length > 0) {
        this.nitem.nextSceneId = this.nitem.choices[0].nextSceneId ?? null;
      }

      if (!this.nitem.choices) {
        this.nitem.choices = [];
      }
      while (this.nitem.choices.length < 3) {
        this.nitem.choices.push({
          textAz: "",
          textEn: "",
          choiceValueId: null,
          isCorrect: false,
          nextSceneId: null,
        });
      }

      this.$nextTick(() => {
        if (this.nitem.choices?.length) {
          this.nitem.nextSceneId = this.nitem.choices[0].nextSceneId ?? null;
        }
      });
    },
    getCharacters() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/Characters")
        .then((response) => {
          this.characters = response.data;
        });
    },
    async GetScenesWithChoices() {
      const response = await jwtInterceptor.get(
        this.$store.getters.getUrl + "/Scenes/GetScenesWithChoices",
      );
      this.scenesWithChoices = response.data;
      console.log(response.data);
    },
    getChoiceValues() {
      jwtInterceptor
        .get(this.$store.getters.getUrl + "/ChoiceValues")
        .then((response) => {
          this.choiceValues = response.data;
        });
    },
    isFormValid() {
      // eslint-disable-next-line vue/no-async-in-computed-properties, no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const valid = await this.$validator.validate();
          resolve(valid);
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  async created() {
    this.id = this.$route.params.id;

    this.getCharacters();
    this.getChoiceValues();
    this.getScenarios();

    await this.GetScenesWithChoices();

    await this.getScene();

    this.nitem.choices = this.nitem.choices.map((c) => ({
      ...c,
      isCorrect:
        c.isCorrect === true ? true : c.isCorrect === false ? false : false, // default
      nextSceneId: c.nextSceneId ?? null,
    }));
  },
};
</script>

<style>
.smsCheckbox {
  height: 2.5rem;
  width: 2rem;
}
</style>
